export default {"src":"/_next/static/media/file-logo.4dc1cd33.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};